/**
 * Compact inline SVG sparkline rendering uptime ratio (0-1) per hour bucket.
 * Each bar's height + colour encodes the operational ratio.
 */
export function UptimeSparkline({ points = [], height = 28, barWidth = 3, gap = 1, testid }) {
  if (!points || points.length === 0) {
    return (
      <div
        className="h-7 flex items-center text-[10px] text-[#9b9f9c]"
        data-testid={testid ? `${testid}-empty` : undefined}
      >
        no data
      </div>
    );
  }
  const stride = barWidth + gap;
  const width = points.length * stride;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      data-testid={testid}
      role="img"
      aria-label="uptime sparkline"
      className="overflow-visible"
    >
      {points.map((p, i) => {
        const ratio = Math.max(0, Math.min(1, p.ratio ?? 0));
        const h = Math.max(2, Math.round(ratio * height));
        const colour = ratio >= 0.99 ? "#114232" : ratio >= 0.9 ? "#d49a36" : "#c15337";
        return (
          <rect
            key={p.hour || i}
            x={i * stride}
            y={height - h}
            width={barWidth}
            height={h}
            rx={1}
            fill={colour}
          >
            <title>{`${p.hour} • ${(ratio * 100).toFixed(1)}% operational`}</title>
          </rect>
        );
      })}
    </svg>
  );
}

export default UptimeSparkline;
